import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CalendarSlugConfirmationDialogData {
  originalSlug: string;
  newSlug: string;
}

@Component({
  selector: 'meeting-scheduler-calendar-slug-confirmation-dialog',
  templateUrl: './calendar-slug-confirmation-dialog.component.html',
  styleUrls: ['./calendar-slug-confirmation-dialog.component.scss'],
  standalone: false,
})
export class CalendarSlugConfirmationDialogComponent {
  constructor(
    private readonly ref: MatDialogRef<CalendarSlugConfirmationDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) readonly data: CalendarSlugConfirmationDialogData,
  ) {}

  onNoClick(): void {
    this.ref.close(false);
  }

  onYesClick(): void {
    this.ref.close(true);
  }
}
